import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import NotFound from "../../Pages/NotFound";

export default function Routing({ routes = [], redirect }) {
  return (
    <Routes>
      {routes.map((route, i) => {
        return (
          <Route
            key={i}
            path={route.path}
            element={
              <route.layout>
                <route.component />
              </route.layout>
            }
          />
        );
      })}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
